import Layout from '@/layout'

const route = {
  path: '/sourceMaterial',
  component: Layout,
  redirect: '/sourceMaterial/index',
  alwaysShow: true, // will always show the root menu
  name: 'sourceMaterial',
  meta: {
    title: '素材中心',
    icon: 'MC',
    roles: [
      'material.center'
    ]
  },
  children: [
    // 图表分析
    {
      path: '/ADsourceMaterial/index',
      component: () => import('@/views/sourceMaterial/index.vue'),
      name: 'ADsourceMaterial',
      meta: {
        title: '广告素材',
        icon: 'component',
        roles: [
          'material.center.ad'
        ]
      }
    },
    {
      path: '/dowloadhfive/index',
      component: () => import('@/views/dowloadhfive/index.vue'),
      name: 'Dowloadhfive',
      meta: {
        title: '素材提交',
        icon: 'component',
        roles: [
          'landing_page_h5'
        ]
      }
    },
    {
      path: '/dowloadhfivedetail/index',
      component: () => import('@/views/dowloadhfivedetail/index.vue'),
      name: 'Dowloadhfivedetail',
      meta: {
        title: '发布人统计',
        // icon: 'component',
        roles: [
          'landing_page_h5'
        ]
      },
      hidden: true
    }
  ]
}

export default route
